module.exports = __webpack_public_path__ + "img/CSCS.bbbab6d.svg";